import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { getKey, isValidArray, exists } from '../../../helpers';
import Questions from '../Questions';
import Text from '../Text';
import Styles from './CategoryFaq.styles';
import PlusIcon from '../Questions/PlusIcon';

const CategoryTitle = styled(Text).attrs({ bold: true })`${Styles.categoryTitle}`; // prettier-ignore
const CategoryIcon = styled.img`${Styles.categoryIcon};`; // prettier-ignore
const CategoryWrapper = styled.div`${Styles.categoryWrapper}`; // prettier-ignore
const QuestionWrapper = styled.div`${Styles.questionWrapper}`; // prettier-ignore

/**
 * CategoryFaq component class
 */
class CategoryFaq extends PureComponent {
  /**
   * Props
   * @property question - true to display the search bar
    */
  static propTypes = {
    key: PropTypes.string,
    category: PropTypes.string,
    icon: PropTypes.string,
    open: PropTypes.bool,
    questions: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string,
        question: PropTypes.string,
        answer: PropTypes.string
      })
    )
  };

  /**
   * Constructor method
   * @param {*} props - component props
   */
  constructor(props) {
    super(props);
    this.toggleAction = this.toggleAction.bind(this);
    this.state = {
      isCategoryOpen: props.open
    };
  }

  toggleAction() {
    this.setState(({ isCategoryOpen }) => ({
      isCategoryOpen: !isCategoryOpen
    }));
  }
  /**
   * render method
   * @returns {?JSX}
   */
  render() {
    const {
      props:{key, category, questions, open, icon},
      state:{isCategoryOpen}
    } = this;
    return (
      <Fragment key={key}>
          {exists(category) && (
            <CategoryWrapper onClick={this.toggleAction}>
            {<CategoryTitle hasIcon={exists(icon)}>
              {exists(icon) && <CategoryIcon src={icon}  onClick={this.handleClick}/>}
              {category}
            </CategoryTitle>}
            {<PlusIcon isActive={isCategoryOpen} />}
          </CategoryWrapper>
          )}
        <QuestionWrapper isActive={isCategoryOpen}>
        {isCategoryOpen && isValidArray(questions)
          && questions.map(item => (
            <Questions
              key={getKey(item, 'key')}
              question={getKey(item, 'question')}
              answer={getKey(item, 'answer')}
              open={false}
            />
          ))}
        </QuestionWrapper>
      </Fragment>
    )
  }
}

export default CategoryFaq;
